import { injectIntl } from "react-intl";
import React from "react";
import moment from "moment";
import "moment/locale/fr";

const withTranslator = WrappedComponent =>
  injectIntl(({ intl, ...props }) => {
    const translate = (message, values) => intl.formatMessage({ id: message, defaultMessage: message }, values);

    const translateHtml = (...args) => <span dangerouslySetInnerHTML={{ __html: translate(...args) }} />;

    const translatePeriod = period => {
      const periodType = period.match("P[0-9]+([A-Z])")[1];

      switch (periodType) {
        case "D":
          return `${moment.duration(period).asDays()} ${translate("jour(s)")}`;
        case "M":
          return `${moment.duration(period).asMonths()} ${translate("mois")}`;
        default:
          return `${moment.duration(period).asMonths()} ${translate("mois")}`;
      }
    };

    const translateDate = date => {
      return moment(date).format("LL");
    };

    return (
      <WrappedComponent
        {...props}
        translate={translate}
        translateHtml={translateHtml}
        intl={intl}
        translatePeriod={translatePeriod}
        translateDate={translateDate}
      />
    );
  });

export default withTranslator;



// WEBPACK FOOTER //
// ./src/app/decorators/withTranslator.js